// pclm-tilelayers-helper.js

/**
 * 
 * 
 * tilelayer interface:
 * [tileLayerName]-[tileLayerId]  | [TileLayerData[url , ...]]
 * 
 * 
 */
var tileLayersManager ={

	_that: null,
	_types:{},
	_properties:{},
	_baseLayers:{},
	_baseLayers_ids:{},
	_overLayers:{},
	_overLayers_ids:{},
	_controls:[],

	init: function(){
		tileLayersManager._that = this;
		tileLayersManager._types={'baselayer':'baselayer','overlay':'overlay'};
	},
	
	initAllTileLayers: function(mapId, tilelayersData,layersControlDisplay){
		
		
		var tilelayersData = tilelayersData || null;
		this._properties[mapId]=this._properties[mapId] || {};
		this._properties[mapId]['layersControlDisplay']=layersControlDisplay;
		
		tileLayersManager.manageRemoteTileLayersData(mapId);
		
		if (tilelayersData != null){
			tileLayersManager.manageLocalTileLayerData(mapId,tilelayersData);
		}

	},

	/**
	 * 
	 */
	createTileLayer: function(tileLayerData){
	 	var tilelayerObj = L.tileLayer(tileLayerData.url);
	 	
	 	if (tilelayerObj){
	 		L.Util.setOptions(tilelayerObj, tileLayerData.options);
	 		tilelayerObj._id = tileLayerData.properties['id'];
	 		tilelayerObj._parents = [tileLayerData.properties['parents']];
	 		
	 	}else{
	 		return false;
	 	}
	 	return tilelayerObj;
	},
	/**
	 * 
	 */
	manageLocalTileLayerData: function(mapId,tilelayersData){
		tileLayersManager.manageTileLayersData(mapId, tilelayersData);
	},

	/**
	 * 
	 */
	manageRemoteTileLayersData: function(mapId){
		jQuery.get(pclm_ajax_object.ajaxurl,
				{	
					"nonce": pclm_ajax_object.nonce_tile_layers_data,
					"action":"tile_layers_data",
					"id":mapId
				},
				function(data){
					tileLayersManager.manageTileLayersData(data.id, data.tileLayers);		
				},
				"json"
			);
	},
	
	manageTileLayersData: function(mapId, tileLayersData){
		
		var map = null;
		var firstBaselayerSet = false;
		var tileLayersLinks = []
		map = mapsManager.getMapElt(mapId);

		tileLayersManager._baseLayers[mapId] = tileLayersManager._baseLayers[mapId] || {}
		tileLayersManager._baseLayers_ids[mapId]= tileLayersManager._baseLayers_ids[mapId]||{};
		tileLayersManager._overLayers[mapId] = tileLayersManager._overLayers[mapId] || {}
		tileLayersManager._overLayers_ids[mapId]= tileLayersManager._overLayers_ids[mapId]||{};		
		
		
		if (tileLayersData != null){
			
			/*adaptative for previous version about tilelayers parents*/
			if (tileLayersData['links']){
				tileLayersLinks = tileLayersData['links'];
				tileLayersData = tileLayersData['list'];
			}
			
			for (var tilelayerTypeIdx in tileLayersData){
				for (var tileLayerIdx in tileLayersData[tilelayerTypeIdx]){
					
					
					var idxsplitted = tileLayerIdx.split("-");
					var tileLayerIdxName = "";
					var tileLayerIdxNumber = "";
					var tileLayer = null;
					
					if (idxsplitted.length == 2){
						tileLayerIdxName = idxsplitted[0];
						tileLayerIdxNumber = idxsplitted[1];
					}
	
					// get or create tilelayer Element
					switch (tilelayerTypeIdx){

						case 'overlay':
						{
							if (!tileLayersManager.getOverLayer(mapId,tileLayerIdxName)){
								tileLayer = tileLayersManager.setOverLayer(mapId, tileLayerIdxName, tileLayerIdxNumber, tileLayersData[tilelayerTypeIdx][tileLayerIdx]);
							}else{
								tileLayer = tileLayersManager.getOverLayer(mapId, tileLayerIdxName );
							}
							break;
						}
						case 'baselayer':
						default:
						{
							if (!tileLayersManager.getBaseLayer(mapId,tileLayerIdxName)){
								tileLayer = tileLayersManager.setBaseLayer(mapId, tileLayerIdxName, tileLayerIdxNumber, tileLayersData[tilelayerTypeIdx][tileLayerIdx]);
							}else{
								tileLayer = tileLayersManager.getBaseLayer(mapId, tileLayerIdxName);
							}
							
						}
					}

					if ((firstBaselayerSet == false) || (tilelayerTypeIdx == 'overlay')){
						
						tileLayer.addTo(map);
						
						if ((firstBaselayerSet == false) && (tilelayerTypeIdx != 'overlay')){
							firstBaselayerSet =true;
						}
					}
					
				}
			}
			
			/* Upodate of tile layers controls of the map */
			tileLayersManager.updateTileLayersControls(mapId);
		}
	
	},
	
	
	getBaseLayer: function(mapId, baseLayerName){
		
		if ( mapId == null || baseLayerName == null){
			return false;
		}else{
			if (tileLayersManager._baseLayers.hasOwnProperty[mapId]){
				return tileLayersManager._baseLayers[mapId][baseLayerName];
			}else{
				return false;
			}
		}
	},
	
	setBaseLayer: function(mapId, baseLayerName, baseLayerId, baseLayerData){
		
		if ( mapId == null || baseLayerName == null || baseLayerId == null || baseLayerData == null ){
			return false;
		}else{
			var baseLayer = tileLayersManager.createTileLayer(baseLayerData);
			if (baseLayer != false){
				tileLayersManager._baseLayers[mapId][baseLayerName] = baseLayer;
				tileLayersManager._baseLayers_ids[mapId][baseLayerId] = baseLayerName;
			}
			return baseLayer;
		}

	},
	
	getOverLayer: function(mapId, overLayerName){
		
		if ( mapId == null || overLayerName == null){
			return false;
		}else{
			if (tileLayersManager._overLayers.hasOwnProperty[mapId]){
				return tileLayersManager._overLayers[mapId][overLayerName];
			}else{
				return false;
			}
		}
	},
	
	setOverLayer: function(mapId, overLayerName, overLayerId, overLayerData){
		
		if ( mapId == null || overLayerName == null || overLayerName == null || overLayerData == null ){
			return false;
		}else{
			var overLayer = tileLayersManager.createTileLayer(overLayerData);
			if (overLayer != false){
				tileLayersManager._overLayers[mapId][overLayerName] = overLayer;
				tileLayersManager._overLayers_ids[mapId][overLayerId] = overLayerName;
			}
			return overLayer;
		}

	},	
	
	updateTileLayersControls: function(mapId = null){
		
		var map = null;
		
		if (mapId == null){ return false ;}
		
		map = mapsManager.getMapElt(mapId);
		
		var controlLayerOptions={};
		if (map.options.collapsed){controlLayerOptions["collapsed"]=map.options.collapsed;}
		if (map.options.autoZIndex){controlLayerOptions["autoZIndex"]=map.options.autoZIndex;}
		if (map.options.hideSingleBase){controlLayerOptions["hideSingleBase"]=map.options.hideSingleBase;}
		if (map.options.sortLayers){controlLayerOptions["sortLayers"]=map.options.sortLayers;}
		
		
		if (this._properties[mapId]['layersControlDisplay']){
			tileLayersManager._controls[mapId]=L.control.layers(tileLayersManager._baseLayers[mapId], tileLayersManager._overLayers[mapId],controlLayerOptions).addTo(map);
			map.layersControl = tileLayersManager._controls[mapId];
		}
		
	},
	
	updateTileLayers: function(mapId,newBaseLayersIds,newOverLayersIds){

		
		
		if(true){
			var rqBaseLayersIds = tileLayersManager.updateBaseLayers(mapId,newBaseLayersIds);
			var rqOverLayersIds = tileLayersManager.updateOverLayers(mapId,newOverLayersIds);
			
			var rqTileLayersIds = Object.assign(rqBaseLayersIds,rqOverLayersIds);
			
			if (rqTileLayersIds){
			jQuery.get(pclm_ajax_object.ajaxurl,
				{
				"nonce": pclm_ajax_object.nonce_tile_layers_data_from_ids,
				"action":"tile_layers_data_from_ids",
				"id":mapId,
				"rq_ids":rqTileLayersIds
				},
				function(data){
					var map = mapsManager.getMapElt(data.id);
					if(!tileLayersManager._baseLayers_ids[data.id])
					{
						tileLayersManager._baseLayers_ids[data.id]=[];
					}
					if (data.tileLayers != false){
						for (var tileLayerIdx in data.tileLayers){
							var tileLayer = tileLayersManager.initTileLayer(data.tileLayers[tileLayerIdx]);
							var idxsplitted = tileLayerIdx.split("-");
							tileLayersManager._baseLayers[data.id][idxsplitted[0]] = tileLayer;
							tileLayersManager._baseLayers_ids[data.id][idxsplitted[1]]=idxsplitted[0];
							tileLayer.addTo(map);
							tileLayersManager._controls[data.id].addBaseLayer(tileLayer,idxsplitted[0]);
							
						}
					}
					
						
				},
				"json");
			}

		}
		else{
			eltToReturn = false;
		}		
	},
	
	updateBaseLayers: function(mapId,newBaselayersId){
		var rqBaseLayersIds= [];
	
		if (tileLayersManager._baseLayers_ids.hasOwnProperty(mapId)){
			for (var newBaselayerId in newBaselayersId){
				if(!tileLayersManager._baseLayers_ids[mapId][newBaselayerId]){
					rqBaseLayersIds.push({'id':newBaselayerId,'type':'baselayer'});
				}		
			}			
		}
		
		for(var _baseLayers_id in tileLayersManager._baseLayers_ids[mapId]){
			if(!newTilelayersId[_baseLayers_id]){
				var map = mapsManager.getMapElt(mapId);
				var returned = map.removeLayer(tileLayersManager._baseLayers[mapId][tileLayersManager._baseLayers_ids[mapId][_baseLayers_id]]);
				tileLayersManager._controls[mapId].removeLayer(tileLayersManager._baseLayers[mapId][tileLayersManager._baseLayers_ids[mapId][_baseLayers_id]]);
				delete tileLayersManager._baseLayers[mapId][tileLayersManager._baseLayers_ids[mapId][_baseLayers_id]];
				delete tileLayersManager._baseLayers_ids[mapId][_baseLayers_id];
			}
		}
		
		return rqBaseLayersIds;
		
	},
	
	updateOverLayers: function(mapId,newOverlayersId){
		var rqOverLayersIds= [];
		
		if (tileLayersManager._overLayers_ids.hasOwnProperty(mapId)){
			rqOverLayersIds[mapId]=[];
			for (var newOverlayerId in newOverlayersId){
				if(!tileLayersManager._overLayers_ids[mapId][newOverlayerId]){
					rqOverLayersIds.push({'id':newOverlayerId,'type':'overlay'});
				}		
			}			
		}
		
		for(var _overLayers_id in tileLayersManager._overLayers_ids[mapId]){
			if(!newTilelayersId[_overLayers_id]){
				var map = mapsManager.getMapElt(mapId);
				var returned = map.removeLayer(tileLayersManager._overLayers[mapId][tileLayersManager._overLayers_ids[mapId][_overLayers_id]]);
				tileLayersManager._controls[mapId].removeLayer(tileLayersManager._overLayers[mapId][tileLayersManager._overLayers_ids[mapId][_overLayers_id]]);
				delete tileLayersManager._overLayers[mapId][tileLayersManager._overLayers_ids[mapId][_overLayers_id]];
				delete tileLayersManager._overLayers_ids[mapId][_overLayers_id];
			}
		}
		
		return rqOverLayersIds;
	},

}

tileLayersManager.init();

L.Map.include({
	addTileLayerLoadStatut:function(tileLayerId){
		this._tileLayersStatus = this._tileLayersStatus || [];
		this._tileLayersStatus[tileLayerId]='loading';
	},
	
	setTileLayerLoadStatut:function(tileLayerId,tileLayerStatut){
		this._tileLayersStatus = this._tileLayersStatus || [];
		this._tileLayersStatus[tileLayerId] = tileLayerStatut;
		
		if (-1 == this._tileLayersStatus.indexOf('loading')){
			this.fire('alltilesload');
		}
	}
});

L.TileLayer.addInitHook(function(){

	this.on('loading', function(e) {
		if (this._map){
			this._map.addTileLayerLoadStatut(L.Util.stamp(e.target))
		}
	})
	
	this.on('load', function(e) {
		if (this._map){
			this._map.setTileLayerLoadStatut(L.Util.stamp(e.target),'loaded')
		}
	})
});

L.Control.Layers.include({
	
	removeOverlays:function(list){
		var layersToRemove = L.layerGroup();
		
		if (list){
			var listIds = list.map(function(v,i,t){return v.layer._id;});
		}
		/*search for layers to remove */
		for(var idx in this._layers){
			if (this._layers[idx].overlay == true && ( (!listIds) || (listIds.indexOf(this._layers[idx].layer._id) !=-1 ))){
				layersToRemove.addLayer(this._layers[idx].layer);
			}
		} 
		/*remove for layers*/
		layersToRemove.eachLayer(function(layer){
			this._map.removeLayer(layer);
			this.removeLayer(layer);
		},this);
		
	},


	updateChildrenOverlays(parentLayer){
		
		var layersToIdle =[];
		var layersToShow =[];
		
		/*find all visible layers to remove*/
		for(var idx in this._layers){
			if (this._layers[idx].overlay == true && ( this._layers[idx].layer._parents.indexOf(parentLayer._id) ==-1 )){
				layersToIdle.push(this._layers[idx]);
			}
		}
		
		var idxToRemove= [];
		/*find all hidden layers to show*/
		for(var idx in this._idleOverlayers){
			if (this._idleOverlayers[idx].overlay == true && ( this._idleOverlayers[idx].layer._parents.indexOf(parentLayer._id) !=-1 )){
				layersToShow.push(this._idleOverlayers[idx]);
				idxToRemove.push(this._idleOverlayers[idx].name);
				
			}
		}
		
		/*Remove ids from idleOverlays*/
		for(var idx in idxToRemove){
			for( var i = 0; i < this._idleOverlayers.length; i++){ 
			   if ( this._idleOverlayers[i].name === idxToRemove[idx]) {
				   this._idleOverlayers.splice(i,1);
				   i--;
			   }
			}					
		}
		
		this._idleOverlayers = this._idleOverlayers.concat(layersToIdle);
		
		/* remove all useless overlays*/
		this.removeOverlays(layersToIdle);

		
		
		/* add all overlays to show*/
		for (var idx in layersToShow){
			this.addOverlay( layersToShow[idx].layer,layersToShow[idx].name);
		}
		
		return;
	}
	
	
})

L.Control.Layers.addInitHook(function(){
	
	
	this._idleOverlayers=[];
	
});

L.Map.addInitHook(function(){
	
	this.on('baselayerchange', function(e) {
		e.target.layersControl.updateChildrenOverlays(e.layer);
	})
	
	
});


